module.exports = __webpack_public_path__ + "static/media/tracy_07.53e353cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/album/tracy_07.jpg
// module id = 385
// module chunks = 0